import React from 'react';
import { DropdownChipLabel as DropdownChipLabelNew } from './DropdownChipLabel';
import { convertOldDropdownChipLabelProps } from './converter.old';
import type { OldDropdownChipLabelProps } from './converter.old';

export type DropdownChipLabelProps<OptionValue> = OldDropdownChipLabelProps<OptionValue>;

export const DropdownChipLabel = React.forwardRef<HTMLDivElement, DropdownChipLabelProps<string | number>>(
  (props, ref) => <DropdownChipLabelNew {...convertOldDropdownChipLabelProps(props)} ref={ref} />,
);
